package pl.decks.personal.components.widgets.progression

import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.CSSPercentageNumericValue
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.em
import pl.decks.personal.styles.FontTypography
import pl.decks.personal.styles.SiteLayout


object RampingProgressionBarStylesheet {
    object Vars {
        val lineWidth by StyleVariable<CSSLengthNumericValue>(SiteLayout.Line.Normal)
        val guideColor by StyleVariable<Color>()
        val fillColor by StyleVariable<Color>()
        val textColor by StyleVariable<Color>()
        val textBackground by StyleVariable<Color>()
        val textSize by StyleVariable(FontTypography.Size.Relative.Smaller)
        val textWidth by StyleVariable<CSSLengthOrPercentageNumericValue>(3.5.em)
        val textHeight by StyleVariable<CSSLengthOrPercentageNumericValue>(1.5.em)
        val textBorderRadius by StyleVariable<CSSLengthOrPercentageNumericValue>(SiteLayout.Rounding.Full)
        val progressWidth by StyleVariable<CSSPercentageNumericValue>(SiteLayout.Fraction.none)
    }

    val Bar = CssStyle.base {
        Modifier
            .borderLeft(
                width = Vars.lineWidth.value(),
                style = LineStyle.Solid,
                color = Vars.fillColor.value(colorMode.toPalette().border),
            )
    }
    val ProgressionCounter = CssStyle.base {
        Modifier
            .minWidth(Vars.textWidth.value())
            .width(Vars.progressWidth.value())
            .flexGrow(0)
    }
    val GuideLine = CssStyle.base {
        Modifier
            .fillMaxWidth()
            .borderTop(
                width = Vars.lineWidth.value(),
                style = LineStyle.Solid,
                color = Vars.guideColor.value(colorMode.toPalette().border),
            )
    }
    val ProgressionLine = CssStyle.base {
        Modifier
            .fillMaxWidth()
            .borderTop(
                width = Vars.lineWidth.value(),
                style = LineStyle.Solid,
                color = Vars.fillColor.value(colorMode.toPalette().border),
            )
    }
    val ProgressionText = CssStyle.base {
        Modifier
            .fontSize(Vars.textSize.value())
            .color(Vars.textColor.value(colorMode.toPalette().color))
            .backgroundColor(Vars.textBackground.value(colorMode.toPalette().background))
            .width(Vars.textWidth.value())
            .height(Vars.textHeight.value())
            .flexShrink(0)
            .borderRadius(Vars.textBorderRadius.value())
            .border(
                width = Vars.lineWidth.value(),
                style = LineStyle.Solid,
                color = Vars.fillColor.value(colorMode.toPalette().border),
            )
    }
}
